import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors as configSelectors } from '../../infrastructure/config';
import SecondaryApplicantWaitingPage from './SecondaryApplicantWaitingPage';

const secondaryApplicantWaiting = ({ bankId }) => <SecondaryApplicantWaitingPage bankId={bankId} />;

secondaryApplicantWaiting.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: configSelectors.bankId(state)
});

export default connect(mapStateToProps)(secondaryApplicantWaiting);
